import { site } from '@shared/site.config';
import { useTitle } from '@/lib/useTitle';
import ServiceSheet from '@/components/ServiceSheet';

const service = site.services[1];

const LEASE_TYPES = ['Gross lease', 'Net (NNN) lease', 'Percentage lease'];

export default function Leasing() {
  useTitle(service.name, service.summary);

  return (
    <ServiceSheet
      sheetNo="A-02"
      service={service}
      glyph="retail"
      tags={LEASE_TYPES}
      tagsLabel="Lease structures"
      interest="leasing"
      ctaLabel="Start a conversation"
      closingLine="Landlord or tenant — across all four cities."
    />
  );
}
